module.exports = __webpack_public_path__ + "img/bus-gray.bd5bb49e.svg";